import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter-lines",
  "use": "filter-lines-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"filter-lines\"><path d=\"M1 4a1 1 0 011-1h12a1 1 0 110 2H2a1 1 0 01-1-1zm1 4a1 1 0 011-1h10a1 1 0 110 2H3a1 1 0 01-1-1zm2 3a1 1 0 100 2h8a1 1 0 100-2H4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol